import { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import { useScrollToTop } from './hooks/useScrollToTop';

import PortalLayout from './containers/PortalLayout';
import PageNotFound from './containers/PageNotFound';
import SignUp from './containers/Auth/SignUp'; // Old
import Registration from './containers/Auth/Registration';
import SignIn from './containers/Auth/SignIn';
import SignedIn from './containers/Auth/SignedIn';
import ForgotPassword from './containers/Auth/ForgotPassword';
import ResetPassword from './containers/Auth/ResetPassword';
import GymMasterScheduling from './containers/GymMaster/Scheduling';
import MemberProfile from './containers/Profiles/MemberProfile';
import TeamProfile from './containers/Profiles/TeamProfile';
import GymProfile from './containers/Profiles/GymProfile';
import MemberInterview from './containers/MemberInterview';
import Feedback from './containers/Feedback';
import SessionWorkMilestones from './containers/SessionWorkMilestones';
import Events from './containers/Events';
import Shred from './containers/Shred';
import EventDetail from './containers/Events/EventDetail';
import EventsAdmin from './containers/Events/EventsAdmin';
import MemberQuestionnaire from './containers/MemberQuestionnaire';
import MainLeaderboards from './containers/MainLeaderboards';
import Leaderboards from './containers/Leaderboards';
import DemoLeaderboard from './containers/DemoLeaderboard';
import DemoIntake from './containers/DemoIntake';
import UnityGems from './containers/UnityGems';
import Community from './containers/Community';
import Seasons from './containers/Seasons';
import SeasonRecap from './containers/SeasonRecap';
import WeekRecap from './containers/WeekRecap';
import ChatPage from './containers/Chat';
import VideoList from './containers/VideoList';
import Workout from './containers/Workout';
import TeamRecap from './containers/TeamRecap';
import PersonalRecords from './containers/PersonalRecords';
import MemberPerformance from './containers/MemberPerformance';
import GymRecap from './containers/GymRecap';
import BattleBreakdown from './containers/BattleBreakdown';
import ErrorBoundary from './components/ErrorBoundary';


function App() {
  useScrollToTop();
  const location = useLocation();

  const [currentPath, setCurrentPath] = useState(null);
  const [previousPath, setPreviousPath] = useState(null);

  useEffect(() => {
    if (location.pathname !== currentPath) {
      setPreviousPath(currentPath);
      setCurrentPath(location.pathname);
    }
  }, [currentPath, location.pathname]);

  return (
    <ErrorBoundary>
      <Routes>
        <Route exact path="registration/v2" element={<Registration />} />
        <Route exact path="registration" element={<SignUp />} />

        <Route element={<PortalLayout />}>
          <Route path="/" element={<Community />} />
          <Route exact path="signup/:gymId" element={<SignUp isScheduling={true} />} />
          <Route exact path="signup" element={<SignUp isScheduling={true} />} />
          <Route exact path="signin" element={<SignIn previousPath={previousPath} />} />
          <Route exact path="signedin" element={<SignedIn />} />
          <Route exact path="forgotpassword" element={<ForgotPassword />} />
          <Route exact path="resetpassword/:recoveryToken" element={<ResetPassword />} />
          <Route exact path="member/:username" element={<MemberProfile />} />
          <Route exact path="team/:teamname" element={<TeamProfile />} />
          <Route exact path="team/:teamname/recaps/raid/season/:season/month/:month" element={<TeamRecap type="post-raid" />} />
          <Route exact path="team/:teamname/recaps/preraid/season/:season/month/:month" element={<TeamRecap type="pre-raid" />} />
          <Route exact path="gym/:id/:gymName" element={<GymProfile />} />
          <Route exact path="gymmaster/scheduling/:userId" element={<GymMasterScheduling />} />
          <Route exact path="gym/:id/:gymName/recaps/preraid/season/:season/month/:month" element={<GymRecap type="pre-raid" />} />
          <Route exact path="main-leaderboards" element={<MainLeaderboards />} />
          <Route exact path="leaderboards" element={<Leaderboards />} />
          <Route exact path="demo-leaderboard" element={<DemoLeaderboard />} />
          <Route exact path="demo-intake" element={<DemoIntake />} />
          <Route exact path="unity-gems" element={<UnityGems />} />
          <Route exact path="seasons" element={<Seasons />} />
          <Route exact path="chat/:userId" element={<ChatPage />} />
          <Route exact path="member/:username/recaps/season/:season" element={<SeasonRecap />} />
          <Route exact path="member/:username/recaps/week/:date" element={<WeekRecap />} />
          <Route exact path="member/:username/workouts" element={<VideoList />} />
          <Route exact path="member/:username/workouts/:sessionId" element={<Workout />} />
          <Route exact path="member/:username/workouts/:sessionId/breakdown" element={<BattleBreakdown />} />
          <Route exact path="member/:username/records" element={<PersonalRecords />} />
          <Route exact path="member/:username/performance" element={<MemberPerformance />} />
          <Route exact path="member/:username/vip/:vipCode" element={<MemberProfile />} />
          <Route exact path="feedback" element={<Feedback />} />
          <Route exact path="feedback/session/:sessionId" element={<Feedback />} />
          <Route exact path="feedback/topic/:topicId" element={<Feedback />} />
          <Route exact path="session-work" element={<SessionWorkMilestones />} />
          <Route exact path="session-work/:milestone" element={<SessionWorkMilestones />} />
          <Route exact path="events" element={<Events />} />
          <Route exact path="events/:eventId" element={<EventDetail />} />
          <Route exact path="events-admin" element={<EventsAdmin />} />
          <Route exact path="shred" element={<Shred />} />
          <Route exact path="404" element={<PageNotFound />} />
        </Route>

        <Route element={<PortalLayout isRequiredAuth />}>
          <Route exact path="interview" element={<MemberInterview />} />
        </Route>

        <Route element={<PortalLayout isHideHeader />}>
          <Route exact path="member/:username/answers" element={<MemberQuestionnaire />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
